/**
 * CommandNotHandledError is an error class that indicates a command was not handled by any registered listener.
 */
export class CommandNotHandledError extends Error {
    /**
     * Constructs a new CommandNotHandledError with a message indicating the command name.
     *
     * @param {string} commandName - The name of the command that was not handled.
     */
    constructor(commandName) {
        super(`No listener returned a valid result for command ${commandName}`);
        this.name = 'CommandNotHandledError';
    }
}
//# sourceMappingURL=CommandNotHandledError.js.map